<template>
	<div class="app-container">
        <v-container fluid class="px-0 px-md-2 pb-0">
			
			<sidemenu v-permission:unless="'employee_site.show'" ></sidemenu>
		
			<navbar class="mx-0 mx-lg-1"></navbar>
			
			<v-main class="mx-0 mx-lg-1 pb-0 main-dashboard">
			
				<!-- <div class="main-container mx-0 mx-md-10"> -->
					<div class="main-container ">
						<!-- <transition name="fade" mode="out-in"> -->
							<router-view></router-view>
						<!-- </transition> -->
					</div>
				<!-- </div> -->
				
				<app-footer v-permission:unless="'employee_site.show'" ></app-footer>
				
			</v-main>
        </v-container>
        <div v-permission:any="'employee_site.show'" class="employee-bar-space"></div>
        <BottomBar v-permission:any="'employee_site.show'"></BottomBar>
	</div>
</template>

<script lang="ts">
    // import VueGatesPlugin from '../plugins/vue-gates';
	import Sidemenu from "../components/Sidemenu.vue"; 
	import AppFooter from "../components/AppFooter.vue";
	import Navbar from "../components/Navbar.vue";
    import BottomBar from "../components/ButtomBar.vue";
	export default {
		name: 'Dashboard',
		components: {
			Navbar,
			Sidemenu,
			AppFooter,
            BottomBar
		},
        computed: {
            routeName: {
                get: function() {
                    if(this.$route.name != 'Login')
                        return true;
                    return false;
                }
               
            },
            
        
        },
        mounted(){
            //VueGatesPlugin.init();
            //console.log(this.$route)
        }
	}
</script>

<style lang="scss">

	.main-container{
		margin: 0 10px;
		// display: flex;
		// flex-direction: column;
		// //height: 89vh;
		// min-height: 89vh;
		// justify-content: space-between;
		min-height: calc(100dvh - 115px) !important;
	}

	.app-container{
		background-color: var(--v-background-base);
        
	}

    .employee-bar-space{
        height: 55px;
    }

	
</style>